<template>
  <th :style="styleObj" @click="sortFunction()">
    <div class="d-flex align-items-end justify-content-between">
      {{ title }}
      
      <div :style="(column === 'town' || column === 'nationality' || column === 'edit') ? 'display: none' : ''">
        <div v-if="sortColumn === column" class="sort-by"  >
        <div v-if="sortByValue === 'asc'">
          <Icon type="md-arrow-round-up" />
        </div>
        <div v-else>
          <Icon type="md-arrow-round-down" />
        </div>
      </div>
      <i v-else class='bx bx-sort-alt-2 sort-by' style="color:#bbbbbb"></i>
      </div>

    </div>
  </th>
</template>
<script>
export default {
  props: [
    'column',
    'title',
    'sortColumn',
    'sortByValue',
    'width'
  ],
  data () {
    return {
      sortColumnLocal: '',
      styleObj: {
        'padding': '10px 5px;'
      }
    }
  },
  methods: {
    sortFunction () {
      this.sortColumnLocal = this.column
      this.$emit('sortBy', this.sortColumnLocal)
    }
  },
  mounted () {
    if (this.width) {
      this.styleObj = {
        ...this.styleObj,
        'width': this.width + 'px;',
        'min-width': this.width + 'px;',
        'max-width': this.width + 'px;'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/helper/table/TableaHeadCol.vue